import { render, staticRenderFns } from "./BaseColumnController.vue?vue&type=template&id=56949523&scoped=true&"
import script from "./BaseColumnController.vue?vue&type=script&lang=js&"
export * from "./BaseColumnController.vue?vue&type=script&lang=js&"
import style0 from "./BaseColumnController.vue?vue&type=style&index=0&id=56949523&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56949523",
  null
  
)

export default component.exports